module.exports = __webpack_public_path__ + "img/282.352967ff.png";